module.exports = __webpack_public_path__ + "img/background_rutscher.14418cf8.jpg";